import React from 'react';

import { black, lightGreen } from 'utils/color-styles';
import { Incentive, IncentiveType } from 'generated/graphql';
import { currencies } from 'utils/currencyFormat';
import { CurrencyFormat } from 'retired/CurrencyFormat';

import { ActionTemplate, IncentiveUnit } from '../types';

export const RewardChip = ({
  actionTemplate,
  isAbsolute,
}: {
  actionTemplate: ActionTemplate;
  isAbsolute: boolean;
}) => {
  const reward = actionTemplate.incentives.find(
    (incentive) => incentive.type === IncentiveType.Reward
  );

  if (!reward) {
    return null;
  }

  const { unit, amount }: Incentive = reward;

  if (!unit) {
    return null;
  }

  // this applies to when donations are 0 dollars or 0 trees
  if (!amount) {
    return null;
  }

  const commonStyle: React.CSSProperties = {
    borderRadius: 4,
    padding: 10,
    backgroundColor: lightGreen,
    fontSize: 12,
    color: black,
    bottom: 16,
    left: 16,
    ...(isAbsolute ? { position: 'absolute' } : { marginTop: 8 }),
  };

  if (unit === IncentiveUnit.tree) {
    const treeText = amount > 1 ? 'trees' : 'tree';
    return (
      <div
        style={{
          ...commonStyle,
        }}
      >
        {`${amount} ${treeText} planted for every action`}
      </div>
    );
  }

  return (
    currencies[unit] && (
      <div
        style={{
          ...commonStyle,
        }}
      >
        1 Action ={' '}
        <CurrencyFormat
          amount={amount}
          baseCurrency={currencies[unit].code}
          targetCurrency={currencies[unit].code}
          short
        />{' '}
        Donation
      </div>
    )
  );
};
